angular.module('core')
  .controller('TimeoutModalController', ['$scope', '$rootScope', 'configuration', function($scope, $rootScope, $configuration) {

    // Handles the timeout modals' instances not a controller for $modal

    $scope.idleMinutes = Math.round($configuration.getIdle().idle / 60);
    $scope.countdownSeconds = Number($configuration.getIdle().timeout);

    $scope.idleReset = function() {
      $rootScope.$broadcast('idleReset');
    };

    $scope.forceTimeout = function() {
      $rootScope.$broadcast('sessionExpired', {abandonedByUser: true});
    };
  }]);
